export const STOPS_FETCH_REQUEST = '@@entities/STOPS_FETCH_REQUEST';
export const STOPS_FETCH_SUCCESS = '@@entities/STOPS_FETCH_SUCCESS';
export const STOPS_FETCH_FAILURE = '@@entities/STOPS_FETCH_FAILURE';
export const fetchStops = () => ({ type: STOPS_FETCH_REQUEST });
